<template>
  <div>
    <page-title title="Add New Content" />
    <content-block-fields :item="item" :isNew="true" v-on:submit="onSubmit" v-on:cancel="onCancel">
      <template v-slot:save>Add</template>
    </content-block-fields>
  </div>
</template>

<script>
import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'

export default {
  name: "ContentBlockAdd",
  mixins: [CrudOperationsMixin],
  props: {},
  data() {
    return {
      item: {
        name: '',
        title: '',
        slug: '',
        description: '',
        value: ''
      }
    };
  },
  methods: {
    onCancel(evt) {
      this.$router.go(-1);
    },
    onSubmit(evt) {
      this.createQuery('/graphql/management', {
        query: `
          mutation ($contentBlock: ContentBlockCreateInputOGT!) {
            createContentBlock(contentBlock: $contentBlock) {
              id,
              name
            }
          }`,
        variables: {
          'contentBlock': this.item
        }}, () => {
          this.$router.push('/contentBlock');
        }, null, 'ContentBlock', this.item.name);
    }   
  },
  mounted () {
  }
};
</script>